import { contractReviewerConstants as constants } from '../constants';
import { authHeader, config, responseHandler } from '../helpers';
import AuthService from '../services/auth.service';

let fileSaver = require("file-saver");
let download = require("downloadjs");

export const contractReviewerActions = {
    deselectDocument,
    requestDocumentsList,
    requestTemplateDocumentsList,
    requestDocumentAnalysis,
    requestNewDocumentAnalysis,
    requestComparisonDocumentAnalysis,
    requestDocumentSegments,
    upload,
    resetUploadState,
    processDocument,
    editDocumentType,
    downloadDocument,
    deleteDocument,
    addTextSegment,
    deleteTextSegment,
    editHighlightNotes,
    editHighlightIsSelected,
    requestCompareDocuments,
    exportAsDocx,
    exportAsExcel,
    getDocumentSummaryAndFeedback
};

function deselectDocument() {
    return async (dispatch) => {
        dispatch({ type: constants.DESELECT_DOCUMENT });
    };
}

function requestDocumentsList() {
    return async (dispatch) => {

        dispatch({ type: constants.GET_DOCUMENTS_LIST_REQUEST });

        try {
            const url = config.documentUrl + '/GetListOfDocuments';
            const requestOptions = {
                method: 'GET',
                headers: authHeader()
            };
            const documents = await fetch(url, requestOptions)
                .then(responseHandler.handleResponse, responseHandler.handleError);

            dispatch({ type: constants.GET_DOCUMENTS_LIST_SUCCESS, documents });
        } catch (exception) {
            dispatch({ type: constants.GET_DOCUMENTS_LIST_FAILURE, exception });
        }
    };
}

function requestTemplateDocumentsList() {
    return async (dispatch) => {

        dispatch({ type: constants.GET_TEMPLATE_DOCUMENTS_LIST_REQUEST });

        try {
            const url = config.documentUrl + '/GetListOfTemplateDocuments';
            const requestOptions = {
                method: 'GET',
                headers: authHeader()
            };
            const data = await fetch(url, requestOptions)
                .then(responseHandler.handleResponse, responseHandler.handleError);

            dispatch({
                type: constants.GET_TEMPLATE_DOCUMENTS_LIST_SUCCESS,
                documents: data.documents,
                templateDocuments: data.templateDocuments
            });
        } catch (exception) {
            dispatch({ type: constants.GET_TEMPLATE_DOCUMENTS_LIST_FAILURE, exception });
        }
    };
}

function requestDocumentAnalysis(id, reportId = false, themeId = false) {
    return async (dispatch) => {

        dispatch({ type: constants.GET_DOCUMENT_ANALYSIS_REQUEST, id, reportId });

        try {
            let url = config.documentUrl + (themeId ? `/GetAnalysisByTheme?id=${id}&themePackageId=${themeId}` : `/GetAnalysis?id=${id}`);
            if (reportId)
                url = config.documentUrl + `/GetPortfolioDocumentAnalysis?id=${id}&reportId=${reportId}`;

            let requestOptions = {
                method: 'GET',
                headers: authHeader()
            };
            const model = await fetch(url, requestOptions).then(responseHandler.handleResponse, responseHandler.handleError);
            if (!model) {
                //dispatch(requestNewDocumentAnalysis(id));
                return;
            }

            url = config.documentUrl + `/GetDocumentImages?id=${id}`;
            requestOptions = {
                method: 'GET',
                headers: authHeader()
            };
            const images = await fetch(url, requestOptions).then(responseHandler.handleResponse, responseHandler.handleError);
            model.images = images;

            dispatch({ type: constants.GET_DOCUMENT_ANALYSIS_SUCCESS, ...model });
        } catch (exception) {
            dispatch({ type: constants.GET_DOCUMENT_ANALYSIS_FAILURE, exception });
        }
    };
}

function requestNewDocumentAnalysis(id) {
    return async (dispatch) => {

        try {
            let url = config.documentUrl + `/RequestNewAnalysis?id=${id}`;

            let requestOptions = {
                method: 'GET',
                headers: authHeader()
            };

            const taskId = await fetch(url, requestOptions)
                .then(responseHandler.handleResponse, responseHandler.handleError);

            dispatch({ type: constants.GET_DOCUMENT_ANALYSIS_PENDING, taskId });
        }
        catch (exception) {
            dispatch({ type: constants.GET_DOCUMENT_ANALYSIS_FAILURE, exception });
        }
    };
}

function requestComparisonDocumentAnalysis(id, themeId = false) {
    return async (dispatch) => {

        dispatch({ type: constants.GET_COMPARISON_DOCUMENT_ANALYSIS_REQUEST, id });

        try {
            const url = config.documentUrl + (themeId ? `/GetAnalysisByTheme?id=${id}&themePackageId=${themeId}` : `/GetAnalysis?id=${id}`);

            const requestOptions = {
                method: 'GET',
                headers: authHeader()
            };
            const model = await fetch(url, requestOptions)
                .then(responseHandler.handleResponse, responseHandler.handleError);

            dispatch({ type: constants.GET_COMPARISON_DOCUMENT_ANALYSIS_SUCCESS, ...model });
        } catch (exception) {
            dispatch({ type: constants.GET_COMPARISON_DOCUMENT_ANALYSIS_FAILURE, exception });
        }
    };
}

function requestDocumentSegments(id) {
    return async (dispatch) => {

        dispatch({ type: constants.GET_DOCUMENT_SEGMENTS_REQUEST });
        try {
            const url = config.documentUrl + `/GetDocumentTextSegments?id=${id}`;
            const requestOptions = {
                method: 'GET',
                headers: authHeader()
            };
            const segments = await fetch(url, requestOptions)
                .then(responseHandler.handleResponse, responseHandler.handleError);

            dispatch({ type: constants.GET_DOCUMENT_SEGMENTS_SUCCESS, id, segments });
        } catch (exception) {
            dispatch({ type: constants.GET_DOCUMENT_SEGMENTS_FAILURE, exception });
        }
    };
}


function upload(files) {

    if (files.length === 1) {
        console.log("Will upload one file")
        let file = files[0];
        return singleUpload(file);
    } else {
        console.log("Will upload: " + files.length + " files")
        return multipleUpload(files);
    }
}

function singleUpload(file) {
    return async (dispatch) => {

        dispatch({ type: constants.START_UPLOAD_SINGLE });

        try {
            const url = config.documentUrl + '/UploadDocument';
            var formData = new FormData();
            formData.append('file', file);

            const model = await fetch(url, {
                method: 'POST',
                body: formData,
                headers: authHeader()
            }).then(responseHandler.handleResponse, responseHandler.handleError);

            new AuthService().consumeFreeReview();

            dispatch({ type: constants.FINISH_UPLOAD_SINGLE, file, ...model });
        }
        catch (exception) {
            dispatch({ type: constants.FAILED_UPLOAD, exception });
        }
    };
}

function multipleUpload(files) {

    let numberOfFilesFinished = 0;

    return async (dispatch) => {
        dispatch({ type: constants.START_UPLOAD_MULTIPLE });

        files.forEach((file) => {
            console.log("Should upload file: " + file.name);

            const url = config.documentUrl + '/UploadDocument';
            let formData = new FormData();
            formData.append('file', file);

            fetch(url,
                {
                    method: 'POST',
                    body: formData,
                    headers: authHeader()
                }
            )
                .then((response) => {
                    if (!response.ok) {
                        throw new Error('Server response for upload was not OK: ' + response.status);
                    }
                })
                .then((success) => {
                    numberOfFilesFinished += 1;
                    console.log("Uploaded file with success: " + file.name + " " + " | (" + numberOfFilesFinished + "/" + files.length + ")");
                    if (numberOfFilesFinished == files.length) {
                        dispatch({ type: constants.FINISH_UPLOAD_MULTIPLE });
                    } else {
                        dispatch({ type: constants.UPDATE_UPLOAD_MULTIPLE, fileName: file.name });
                    }
                    new AuthService().consumeFreeReview();
                })
                .catch((error) => {
                    numberOfFilesFinished += 1;
                    console.error('There has been a problem with upload files operation:', error);
                    dispatch({ type: constants.UPDATE_UPLOAD_MULTIPLE, fileName: file.name, uploadError: error });
                });
        })
    };
}

function resetUploadState() {
    return async (dispatch) => {
        dispatch({ type: constants.RESET_UPLOAD_STATE });
    };
}

function processDocument(id) {
    return async (dispatch) => {

        dispatch({ type: constants.PROCESS_DOCUMENT_REQUEST });

        try {
            const url = config.documentUrl + `/ProcessDocument?id=${id}`;
            const requestOptions = {
                method: 'GET',
                headers: authHeader()
            };
            await fetch(url, requestOptions)
                .then(responseHandler.handleResponse, responseHandler.handleError);

            dispatch({ type: constants.PROCESS_DOCUMENT_SUCCESS });
        } catch (exception) {
            dispatch({ type: constants.PROCESS_DOCUMENT_FAILURE, exception });
        }
    };
}

function editDocumentType(id, type, isUploading = false) {
    return async (dispatch) => {

        dispatch({ type: constants.EDIT_DOCUMENT_TYPE_REQUEST, contractType: type, isUploading });

        try {
            const url = config.documentUrl + `/EditDocumentType?id=${id}&type=${type}`;
            const requestOptions = {
                method: 'GET',
                headers: authHeader()
            };
            await fetch(url, requestOptions)
                .then(responseHandler.handleResponse, responseHandler.handleError);

            dispatch({ type: constants.EDIT_DOCUMENT_TYPE_SUCCESS, isUploading });
        } catch (exception) {
            dispatch({ type: constants.EDIT_DOCUMENT_TYPE_FAILURE, exception });
        }
    };
}

function downloadDocument(id) {
    return async (dispatch) => {

        dispatch({ type: constants.DOWNLOAD_DOCUMENT_REQUEST });

        try {
            const url = config.documentUrl + `/DownloadDocument?id=${id}`;
            const requestOptions = {
                method: 'GET',
                headers: authHeader()
            };
            let data = await fetch(url, requestOptions)
                .then(responseHandler.handleResponse, responseHandler.handleError);

            fileSaver.saveAs(new Blob([data], { type: "application/octet-stream" }), data.filename);

            dispatch({ type: constants.DOWNLOAD_DOCUMENT_SUCCESS });
        } catch (exception) {
            dispatch({ type: constants.DOWNLOAD_DOCUMENT_FAILURE, exception });
        }
    };
}

function deleteDocument(id) {
    return async (dispatch) => {

        dispatch({ type: constants.DELETE_DOCUMENT_REQUEST });

        try {
            const url = config.documentUrl + `/DeleteDocument?id=${id}`;
            const requestOptions = {
                method: 'GET',
                headers: authHeader()
            };
            await fetch(url, requestOptions)
                .then(responseHandler.handleResponse, responseHandler.handleError);

            dispatch({ type: constants.DELETE_DOCUMENT_SUCCESS, id });
        } catch (exception) {
            console.log(exception);
            dispatch({ type: constants.DELETE_DOCUMENT_FAILURE, exception });
        }
    };
}

function addTextSegment(id, html, text, startPos) {
    return async (dispatch) => {

        dispatch({ type: constants.ADD_TEXT_SEGMENT_REQUEST });

        try {
            const url = config.documentUrl + `/AddTextSegment?id=${id}&html=${html}&text=${text}&startPos=${startPos}`;
            const requestOptions = {
                method: 'GET',
                headers: authHeader()
            };
            let segment = await fetch(url, requestOptions)
                .then(responseHandler.handleResponse, responseHandler.handleError);

            dispatch({ type: constants.ADD_TEXT_SEGMENT_SUCCESS, id, segment });
        } catch (exception) {
            dispatch({ type: constants.ADD_TEXT_SEGMENT_FAILURE, exception });
        }
    };
}

function deleteTextSegment(id) {
    return async (dispatch) => {

        dispatch({ type: constants.DELETE_TEXT_SEGMENT_REQUEST });

        try {
            const url = config.documentUrl + `/DeleteTextSegment?id=${id}`;
            const requestOptions = {
                method: 'GET',
                headers: authHeader()
            };
            await fetch(url, requestOptions)
                .then(responseHandler.handleResponse, responseHandler.handleError);

            dispatch({ type: constants.DELETE_TEXT_SEGMENT_SUCCESS, id });
        } catch (exception) {
            dispatch({ type: constants.DELETE_TEXT_SEGMENT_FAILURE, exception });
        }
    };
}

function editHighlightNotes(id, textSegmentId, categoryCode, text) {
    return async (dispatch) => {

        dispatch({ type: constants.EDIT_HIGHLIGHT_NOTES_REQUEST });

        try {
            const url = config.documentUrl + '/EditHighlightNotes';
            const requestOptions = {
                method: 'POST',
                headers: {
                    ...authHeader(),
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    Id: id,
                    TextSegmentId: textSegmentId,
                    CategoryCode: categoryCode,
                    Text: text
                })
            };
            await fetch(url, requestOptions)
                .then(responseHandler.handleResponse, responseHandler.handleError);

            dispatch({ type: constants.EDIT_HIGHLIGHT_NOTES_SUCCESS, id, textSegmentId, categoryCode, notes: text });
        } catch (exception) {
            dispatch({ type: constants.EDIT_HIGHLIGHT_NOTES_FAILURE, exception });
        }
    };
}

function editHighlightIsSelected(id, textSegmentId, categoryCode, isSelected) {
    return async (dispatch) => {

        dispatch({ type: constants.EDIT_HIGHLIGHT_IS_SELECTED_REQUEST });

        try {
            const url = config.documentUrl + `/EditHighlightIsSelected?id=${id}&textSegmentId=${textSegmentId}&categoryCode=${categoryCode}&isSelected=${isSelected}`;
            const requestOptions = {
                method: 'GET',
                headers: authHeader()
            };
            await fetch(url, requestOptions)
                .then(responseHandler.handleResponse, responseHandler.handleError);

            dispatch({ type: constants.EDIT_HIGHLIGHT_IS_SELECTED_SUCCESS, id, textSegmentId, categoryCode, isSelected });
        } catch (exception) {
            dispatch({ type: constants.EDIT_HIGHLIGHT_IS_SELECTED_FAILURE, exception });
        }
    };
}

function requestCompareDocuments(baseId, newId) {
    return async (dispatch) => {

        dispatch({ type: constants.COMPARE_DOCUMENTS_REQUEST, id: `${newId}-${baseId}` });

        try {
            const url = config.documentUrl + `/GetComparison?baseId=${baseId}&comparisonId=${newId}`;
            const requestOptions = {
                method: 'GET',
                headers: authHeader()
            };
            const model = await fetch(url, requestOptions).then(responseHandler.handleResponse, responseHandler.handleError);

            dispatch({ type: constants.GET_COMPARISON_DOCUMENT_ANALYSIS_SUCCESS, ...model.baseDocument });
            dispatch({ type: constants.COMPARE_DOCUMENTS_SUCCESS, ...model.deviationDocument });
        } catch (exception) {
            dispatch({ type: constants.GET_COMPARISON_DOCUMENT_ANALYSIS_FAILURE, exception });
            dispatch({ type: constants.COMPARE_DOCUMENTS_FAILURE, exception });
        }
    };
}

function exportAsDocx(documentId, visibleSections) {
    return async (dispatch) => {

        dispatch({ type: constants.EXPORT_AS_DOCX_REQUEST });

        try {
            const url = config.documentUrl + `/ExportAsDocx?id=${documentId}&sections=${JSON.stringify(visibleSections)}`;
            const requestOptions = {
                method: 'GET',
                headers: authHeader()
            };
            let file = await fetch(url, requestOptions).then(responseHandler.handleResponse, responseHandler.handleError);
            download(file, file.name);

            dispatch({ type: constants.EXPORT_AS_DOCX_SUCCESS });
        } catch (exception) {
            dispatch({ type: constants.EXPORT_AS_DOCX_FAILURE, exception });
        }
    };
}

function exportAsExcel(documentId, visibleSections) {
    return async (dispatch) => {

        dispatch({ type: constants.EXPORT_AS_EXCEL_REQUEST });

        try {
            const url = config.documentUrl + `/ExportAsExcel?id=${documentId}&sections=${JSON.stringify(visibleSections)}`;
            const requestOptions = {
                method: 'GET',
                headers: authHeader()
            };
            let file = await fetch(url, requestOptions).then(responseHandler.handleResponse, responseHandler.handleError);
            download(file, file.name);

            dispatch({ type: constants.EXPORT_AS_EXCEL_SUCCESS });
        } catch (exception) {
            dispatch({ type: constants.EXPORT_AS_EXCEL_FAILURE, exception });
        }
    };
}

function getDocumentSummaryAndFeedback(id, forceRefresh = false) {
    return async (dispatch) => {
        dispatch({ type: constants.GET_DOCUMENT_SUMMARY_REQUEST, id });

        const localKey = `documentSummary_${id}`;

        if (!forceRefresh) {
            // Try to get from localStorage
            let cached = null;
            try {
                const cachedString = localStorage.getItem(localKey);
                if (cachedString) {
                    cached = JSON.parse(cachedString);
                }
            } catch (e) {
                console.warn('Error reading from localStorage:', e);
            }

            if (cached) {
                dispatch({ type: constants.GET_DOCUMENT_SUMMARY_SUCCESS, id, summary: cached });
                return;
            }
        }

        // Not cached → fetch from server
        try {
            const url = config.documentUrl + `/GetFeedbackAndSummaryForDocument?id=${id}`;
            const requestOptions = {
                method: 'GET',
                headers: authHeader()
            };
            let result = await fetch(url, requestOptions)
                .then(responseHandler.handleResponse, responseHandler.handleError);

            let parsed = null;
            try {
                parsed = JSON.parse(result);
            } catch (e) {
                console.error('Failed to parse JSON:', e);
            }

            // Save to localStorage
            try {
                localStorage.setItem(localKey, JSON.stringify(parsed));
            } catch (e) {
                console.warn('Error writing to localStorage:', e);
            }

            dispatch({ type: constants.GET_DOCUMENT_SUMMARY_SUCCESS, id, summary: parsed });
        } catch (exception) {
            dispatch({ type: constants.GET_DOCUMENT_SUMMARY_FAILURE, exception });
        }
    };
}


// WEBPACK FOOTER //
// ./src/actions/contractReviewer.actions.js